module.exports = __webpack_public_path__ + "img/1547438786.1a138961.jpg";